"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subtitle = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Text_atom_1 = require("../atoms/Text.atom");
const Styled = styled_components_1.default.div `
	margin-bottom: 16px;

	.footer-text {
		font-weight: 500;
		font-size: 13px;
		line-height: 18px;
		letter-spacing: 3px;
		color: ${(p) => p.theme.palette.text.eyebrow};
		font-family: ${(p) => p.theme.fonts.heading4 || p.theme.fonts.default};
		text-transform: uppercase;
	}

	&.split {
		${(p) => p.theme.breakpoints.down("sm")} {
			text-align: center;
		}
	}
`;
const Subtitle = ({ subTitle, split }) => {
    return (react_1.default.createElement(Styled, { className: `subTitle ${split ? "split" : ""}` },
        react_1.default.createElement(Text_atom_1.Text, null, subTitle)));
};
exports.Subtitle = Subtitle;
//# sourceMappingURL=Subtitle.atom.js.map